<template>
    <div>
        <v-card>
            <v-toolbar color="white" dense flat>
                <v-toolbar-title>Histórico de puestos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom v-if="puedeAdministrar">
                    <v-btn icon slot="activator" @click="agregarDialog()">
                        <v-icon>add</v-icon>
                    </v-btn>
                    <span>Agregar puesto</span>
                </v-tooltip>
            </v-toolbar>

            <v-card-title v-if="puestos.length === 0">No hay puestos capturados</v-card-title>

            <v-list v-else three-line>
                <template v-for="(puesto, index) in puestos">
                    <v-list-tile :key="index">
                        <v-list-tile-action>
                            <v-icon v-if="puesto.actual" color="orange">star</v-icon>
                            <!-- <v-icon v-else color="grey">star</v-icon> -->
                        </v-list-tile-action>

                        <v-list-tile-content>
                        <v-list-tile-title>{{puesto.puesto}}</v-list-tile-title>
                        <v-list-tile-sub-title>Inicio: {{ fechaFormato(puesto.inicio)}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title>Fin: {{fechaFormato(puesto.fin)}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-menu
                                v-if="puedeAdministrar"
                                transition="scale-transition"
                                origin="right top"
                                bottom
                                left
                            >
                                <v-btn class="ma-0" icon slot="activator">
                                    <v-icon color="grey">more_vert</v-icon>
                                </v-btn>
                                <v-list class="app-card-action">
                                    <v-list-tile @click="modificarDialog(puesto)">
                                        <i class="fa fa-edit blue--text mr-2 fs-14"></i>
                                        <span>Modificar datos</span>
                                    </v-list-tile>
                                    <v-list-tile v-if="!puesto.actual" @click="asignarActual(puesto._id)">
                                        <i class="fa fa-star orange--text mr-2 fs-14"></i>
                                        <span>Establecer como puesto actual</span>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <!-- <v-btn icon ripple>
                                <v-icon color="grey">more_vert</v-icon>
                            </v-btn> -->
                        </v-list-tile-action>
                    </v-list-tile>
                </template>
                <!-- <v-divider></v-divider> -->
            </v-list>

        </v-card>

        <!-- DIALOG PARA AGREGAR PUESTO -->
        <v-dialog v-model="agregar.mostrar" persistent max-width="700px">  
            <v-card class="elevation-10">
                <v-toolbar >
                    <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                    <v-card-title><h3>Agregar puesto</h3></v-card-title>
                </v-toolbar>
                <v-card-title>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md12>
                            <v-autocomplete
                                v-model="agregar.puesto"
                                :items="listaPuestos"
                                label="Puesto"
                                prepend-icon="mdi-city"
                            >
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-container>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="normal" @click="agregar.mostrar = false">Cancelar</v-btn>
                    <v-btn small color="primary" @click="agregarPuesto()">Agregar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- DIALOG PARA MODIFICAR PUESTO -->
        <v-dialog v-model="modificar.mostrar" persistent max-width="700px">  
            <v-card class="elevation-10">
                <v-toolbar >
                    <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                    <v-card-title><h3>Modificar puesto</h3></v-card-title>
                </v-toolbar>
                <v-card-title>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                        <v-text-field
                            label="Puesto:"
                            v-model="modificar.puesto"
                        ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                            <v-menu
                                v-model="modificar.iniCal"
                                :close-on-content-click="false"
                                full-width
                                max-width="290"
                                >
                                <v-text-field
                                    :value="modificarFechaInicio"
                                    label="Fecha de inicio"
                                    slot="activator"
                                ></v-text-field>
                                <v-date-picker
                                    v-model="modificar.inicio"
                                    @change="modificar.iniCal = false"
                                    locale="es"
                                    :max="maxDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                            <v-menu
                                v-model="modificar.finCal"
                                :close-on-content-click="false"
                                full-width
                                max-width="290"
                                :disabled="modificar.actual"
                                >
                                <v-text-field
                                    :value="modificarFechaFin"
                                    label="Fecha de fin"
                                    slot="activator"
                                    :disabled="modificar.actual"
                                ></v-text-field>
                                <v-date-picker
                                    v-model="modificar.fin"
                                    @change="modificar.finCal = false"
                                    locale="es"
                                    reactive
                                    :max="maxDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>
                    
                    </v-layout>
                </v-container>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="normal" @click="modificar.mostrar = false">Cancelar</v-btn>
                    <v-btn small color="primary" @click="modificarPuesto()">Agregar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from 'axios'

export default {
    name: 'HistoricoPuestos',
    props:['puestos'],
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "permisos",
            "role"
        ]),
        puedeAdministrar(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 167) >= 0 
        },
        modificarFechaInicio(){
          moment.locale('es');
          return this.modificar.inicio ? moment(this.modificar.inicio).format('LL') : ''
        },
        modificarFechaFin(){
          moment.locale('es');
          return this.modificar.fin ? moment(this.modificar.fin).format('LL') : ''
        }
    },
    data() {
        return {
            id: this.$route.params.id,
            listaPuestos:[],
            agregar:{
                mostrar: false,
                puesto: null,
            },
            modificar:{
                mostrar: false,
                iniCal:null,
                finCal:null,
                id: null,
                puesto: null,
                inicio: null,
                fin: null,
                actual: false
            },
            maxDate: new Date().toISOString()
        }
    },
    created(){
        //Se obtiene el listado de puestos
        this.$emit('enviandoStart');
        axios.get(this.httpURL+'/personal/historico/puestos/listado',{headers:{token: this.sessionToken}})
            .then(res => {
                res.data.puestos.forEach(element => {
                    this.listaPuestos.push(element.nombre);    
                });
                this.$emit('enviandoStop');
                // this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.$emit('enviandoStop');
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    methods:{
        agregarDialog(){
            this.agregar.puesto = null;
            this.agregar.mostrar = true;
        },
        agregarPuesto(){
            if( this.agregar.puesto ){
                this.$emit('enviandoStart');
                axios.post(this.httpURL+'/personal/historico/puestos/agregar',
                    {id:this.id,puesto:this.agregar.puesto},
                    {headers:{token: this.sessionToken}})
                    .then(res => {
                        this.agregar.mostrar = false;
                        this.$emit('enviandoStop');
                        this.$emit('puestoAgregado',res.data.puesto);
                        this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                    })
                    .catch(error => {
                        // console.log(error);
                        this.$emit('enviandoStop');
                        this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                    });
            }else
                this.agregar.mostrar = false;
        },
        asignarActual(id){
            this.$emit('enviandoStart');
            axios.put(this.httpURL+'/personal/historico/puestos/actual',
                {idUsuario:this.id,idPuesto:id},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    this.agregar.mostrar = false;
                    this.$emit('enviandoStop');
                    this.$emit('puestoActual',id,res.data.puesto);
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.$emit('enviandoStop');
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        modificarDialog(puesto){
            this.modificar.id = puesto._id;
            this.modificar.puesto = puesto.puesto;
            this.modificar.inicio = puesto.inicio ? moment(puesto.inicio).format('YYYY-MM-DD') :null;
            this.modificar.fin = puesto.fin ? moment(puesto.fin).format('YYYY-MM-DD') :null;
            // this.modificar.inicio = puesto.inicio;
            // this.modificar.fin = puesto.fin;
            this.modificar.actual = puesto.actual;
            this.modificar.mostrar = true;
        },
        modificarPuesto(){
            this.$emit('enviandoStart');
            axios.put(this.httpURL+'/personal/historico/puestos/modificar',
                {
                    id:this.id,
                    idPuesto:this.modificar.id,
                    puesto:this.modificar.puesto,
                    inicio:moment(this.modificar.inicio).toISOString(),
                    fin:moment(this.modificar.fin).toISOString(),
                    // fin:this.modificar.fin,
                },
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res.data.puesto);
                    this.modificar.mostrar = false;
                    this.$emit('enviandoStop');
                    this.$emit('puestoModificado',res.data.puesto);
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.$emit('enviandoStop');
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        fechaFormato(fecha){
            return  fecha ? moment(fecha).format('LL') : 'No especificado';
        }
    }
}
</script>